import React from 'react';
import { PageSection } from '../../Layout';
import SieveSetDimensionsSection from './SieveSetDimensionsSection';
import SieveSetSieveGridSection from './SieveSetSieveGridSection';

const SieveSetEquipment = () => {
  return (
    <PageSection heading="Sieve Set">
      <SieveSetDimensionsSection />
      <SieveSetSieveGridSection />
    </PageSection>
  );
};

export default SieveSetEquipment;
export { SieveSetEquipment };
